import React from 'react';
import { bool, func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';

import SectionContainer from '../SectionContainer';
import css from './SectionHero.module.css';
import { PrimaryButton } from '../../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

// Section component for a website's hero section
// The Section Hero doesn't have any Blocks by default, all the configurations are made in the Section Hero settings
const SectionHero = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    // callToAction,
    options,
    isLandingPage,
  } = props;
  let { callToAction } = props;
  const history = useHistory();
  const state = useSelector(state => state);
  const { currentUser } = state?.user || {};
  const notCurrentUser = !(currentUser && currentUser?.id?.uuid);
  callToAction = notCurrentUser ? { ...callToAction, href: '/signup' } : callToAction;
  const intl = useIntl();
  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  const showButtons = isLandingPage && currentUser && currentUser?.id?.uuid;
  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={classNames(rootClassName || css.root)}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
          {!showButtons ? (
            <Field
              data={callToAction}
              className={defaultClasses.ctaButton}
              options={fieldOptions}
            />
          ) : null}
          {
            showButtons? <div className={css.containerGetting}><PrimaryButton 
            className={css.gettingstartedButton} 
            onClick={() => history.push('/p/welcome-new-members')}
            >
            Getting Started
            </PrimaryButton> </div>:null
          }
          {/* {isLandingPage && currentUser && currentUser?.id?.uuid ? (
            <div className={css.buttons}>
              <PrimaryButton
                className={css.listingLinkButton}
                onClick={() => history.push('/s?pub_listingType=fem-x-profile')}
              >
                {intl.formatMessage({ id: 'SectionHero.SectionHero.femxProfile' })}
              </PrimaryButton>
              <PrimaryButton
                className={css.listingLinkButton}
                onClick={() => history.push('/s?pub_listingType=Xchange_Listing')}
              >
                {intl.formatMessage({ id: 'SectionHero.SectionHero.exchangeListing' })}
              </PrimaryButton>
            </div>
          ) : null} */}
        </header>
      ) : null}
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionHero.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  isInsideContainer: false,
  options: null,
};

SectionHero.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionHero;
